var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarpetLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A84292B1-1FAD-400A-9E2E-784144850688") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-130.000000, -2347.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.000000, 990.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carpet-light",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,0 C0.5625,0 0,0.5625 0,1.25 C0,1.9375 0.5625,2.5 1.25,2.5 L2.5,2.5 L2.5,7.5 L1.25,7.5 C0.5625,7.5 0,8.0625 0,8.75 C0,9.4375 0.5625,10 1.25,10 L2.5,10 L2.5,13.75 L1.25,13.75 C0.5625,13.75 0,14.3125 0,15 C0,15.6875 0.5625,16.25 1.25,16.25 L2.5,16.25 L2.5,20 L1.25,20 C0.5625,20 0,20.5625 0,21.25 C0,21.9375 0.5625,22.5 1.25,22.5 L2.5,22.5 L2.5,27.5 L1.25,27.5 C0.5625,27.5 0,28.0625 0,28.75 C0,29.4375 0.5625,30 1.25,30 L2.5,30 L3.75,30 L5,30 L45,30 L46.25,30 L47.5,30 L48.75,30 C49.4375,30 50,29.4375 50,28.75 C50,28.0625 49.4375,27.5 48.75,27.5 L47.5,27.5 L47.5,22.5 L48.75,22.5 C49.4375,22.5 50,21.9375 50,21.25 C50,20.5625 49.4375,20 48.75,20 L47.5,20 L47.5,16.25 L48.75,16.25 C49.4375,16.25 50,15.6875 50,15 C50,14.3125 49.4375,13.75 48.75,13.75 L47.5,13.75 L47.5,10 L48.75,10 C49.4375,10 50,9.4375 50,8.75 C50,8.0625 49.4375,7.5 48.75,7.5 L47.5,7.5 L47.5,2.5 L48.75,2.5 C49.4375,2.5 50,1.9375 50,1.25 C50,0.5625 49.4375,0 48.75,0 L47.5,0 L46.25,0 L45,0 L5,0 L3.75,0 L2.5,0 L1.25,0 Z M5,2.5 L10,2.5 L10,27.5 L5,27.5 L5,21.25 L5,15 L5,8.75 L5,2.5 Z M40,2.5 L45,2.5 L45,8.75 L45,15 L45,21.25 L45,27.5 L40,27.5 L40,2.5 Z M37.5,2.5 L37.5,27.5 L12.5,27.5 L12.5,2.5 L37.5,2.5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpetLight);
export default __webpack_public_path__ + "static/media/carpet-light.cefcd1ec849f69b5462f585119edbb2a.svg";
export { ForwardRef as ReactComponent };